
import Vue from 'vue'

// Interfaces for component typechecking!
interface AppComputed {
	total: number
    filterAmount: number
    showSearchHits: boolean
}

export default Vue.extend<{}, {}, AppComputed, {}>({
	name: 'ResultText',
	computed: {
		total() {
			return this.$store.getters.total
		},
        filterAmount() {
            return this.$store.getters.filterAmount
        },
        showSearchHits() {
			return this.$store.getters.showSearchHits
		},
	},
	methods: {},
})
